import React from "react";
import { getFlagUrl } from "./Utils/getFlagUrl";

const SprintSeriesMobile = ({ data, boldRows, rowRange, discipline }) => {
  const isSpacer = (row) => row.every((cell) => !cell || cell.trim() === "");

  const getHeats = (row) => {
    const heats = [];
    for (let i = 5; i < row.length; i += 2) {
      const rank = row[i] || "";
      const time = row[i + 1] || "";
      if (rank || time) heats.push({ rank, time });
    }
    return heats;
  };

  const renderRider = (row, i) => {
    const rowNumber = rowRange[0] + i + 1;
    const isBold = boldRows.includes(rowNumber);
    const rank = row[0] || "";
    const lastName = row[2] || "";
    const firstName = row[3] || "";
    const country = row[4] || "";
    const heats = getHeats(row);

    return (
      <div key={i} className={`ssm-rider ${isBold ? "bold-row" : ""}`}>
        <div className="ssm-row1">
          <div className="ssm-left">
            <div className="ssm-rank-name">
              <div className="ssm-rank">{rank}</div>
              <div className="ssm-name-flag">
                <div className="ssm-last-name">{lastName}</div>
                <img src={getFlagUrl(country)} alt={country} className="flag-icon inline-flag" />
              </div>
            </div>
            <div className="ssm-first-name">{firstName}</div>
          </div>
          <div className="ssm-right">
            {heats.map((heat, idx) => (
              <div key={idx} className="ssm-heat">
                <div className={`ssm-heat-rank ${heat.rank.toLowerCase() === "winner" ? "winner-cell" : ""}`}>
                  {heat.rank}
                </div>
                <div className="ssm-time">{heat.time}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const renderHeaderRow = (text, key) => (
    <div className="ssm-final-header" key={`header-${key}`}>
      <div className="final-header-cell">{text}</div>
    </div>
  );

  const isRealFinals = () =>
    /^sprint (me|we|mj|wj) finals$/i.test(discipline?.trim());
  

  return (
    <div className="mobile-sprint-series">
      {(() => {
        const renderedRows = [];

        for (let i = 1; i < data.length; i++) {
          const row = data[i];
          const nextRow = data[i + 1];

          if (isSpacer(row)) continue;

          const isHeaderRow = row[0]?.toLowerCase().includes("rnk") && row[2]?.toLowerCase().includes("last name");
          if (isHeaderRow) continue;

          const isNextRowInvalid =
            !nextRow ||
            isSpacer(nextRow) ||
            nextRow[0]?.toLowerCase().includes("rnk") ||
            nextRow[2]?.toLowerCase().includes("last name");

          if (isNextRowInvalid) continue;

          // Přidání pevného textu pouze pro Sprint Finals
          if (isRealFinals()) {
            const currentIndex = renderedRows.length;
            const headerText = currentIndex === 0 ? "FINAL FOR BRONZE" : "FINAL FOR GOLD";
            renderedRows.push(renderHeaderRow(headerText, `manual-${currentIndex}`));
          }

          renderedRows.push(
            <div key={i} className="ssm-battle">
              {renderRider(row, i)}
              {renderRider(nextRow, i + 1)}
            </div>
          );

          i++;
        }

        return renderedRows;
      })()}
    </div>
  );
};

export default SprintSeriesMobile;
